import React, { forwardRef, Ref } from 'react';
import { InitialsField as InitialsFieldData } from '@dropbox/sign-internal-client';
import { ImperativeAPI } from '../types/imperative-api';
import { SignatureImage } from './signature-image';

type Props = {
  fieldData: InitialsFieldData;
  isFormView?: boolean;
  onKeyPress?: (event: React.KeyboardEvent) => void;
  onTouchEnd?: (event: React.TouchEvent) => void;
  onClick?: (event: React.MouseEvent) => void;
  tabIndex?: number;
  'data-qa-ref'?: string;
  'data-testid'?: string;
};

function InitialsFieldInternal(
  {
    fieldData,
    isFormView,
    onKeyPress,
    onTouchEnd,
    onClick,
    tabIndex,
    'data-qa-ref': dataQaRef,
    'data-testid': dataTestId,
  }: Props,
  ref: Ref<ImperativeAPI>,
) {
  if (fieldData.signature != null) {
    return (
      <SignatureImage
        isFormView={isFormView}
        signer={fieldData.signer}
        signatureGuid={fieldData.signature.guid}
        onKeyPress={onKeyPress}
        onTouchEnd={onTouchEnd}
        onClick={onClick}
        tabIndex={tabIndex}
        data-qa-ref={dataQaRef}
        data-testid={dataTestId}
        ref={ref}
      />
    );
  }

  return null;
}

export const InitialsField = forwardRef(InitialsFieldInternal);
